"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridContent = exports.HeadingWrapper = exports.IconWrapper = exports.DialogActions = exports.DialogContent = exports.Dialog = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _spacing = _interopRequireDefault(require("../../theme/spacing"));

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    text-align: ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  &&& {\n    padding: ", " ", " ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  &&& {\n    padding: ", " ", " 0;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  &&& {\n    padding: ", " 0 ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  &&& {\n    padding-top: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    .MuiDialog-paper {\n      padding: ", ";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Dialog = (0, _styledComponents["default"])(_Dialog["default"])(_templateObject(), _spacing["default"][1]);
exports.Dialog = Dialog;
var DialogContent = (0, _styledComponents["default"])(_DialogContent["default"])(_templateObject2(), _spacing["default"][10]);
exports.DialogContent = DialogContent;
var DialogActions = (0, _styledComponents["default"])(_DialogActions["default"])(_templateObject3(), _spacing["default"][6], _spacing["default"][8]);
exports.DialogActions = DialogActions;
var IconWrapper = (0, _styledComponents["default"])(_Grid["default"])(_templateObject4(), _spacing["default"][1], _spacing["default"][12]);
exports.IconWrapper = IconWrapper;
var HeadingWrapper = (0, _styledComponents["default"])(_Grid["default"])(_templateObject5(), _spacing["default"][1], _spacing["default"][2], _spacing["default"][2]);
exports.HeadingWrapper = HeadingWrapper;

var GridStripped = function GridStripped(_ref) {
  var textAlign = _ref.textAlign,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["textAlign"]);
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], props);
};

var GridContent = (0, _styledComponents["default"])(GridStripped)(_templateObject6(), function (props) {
  return props.textAlign;
});
exports.GridContent = GridContent;